import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// Third-Party Libraries
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgxEditorModule } from 'ngx-editor';
import { NgxMaskModule } from 'ngx-mask';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ClipboardModule } from 'ngx-clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ToastrModule } from 'ngx-toastr';
import { LightboxModule } from 'ngx-lightbox';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastModule } from 'primeng/toast';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { TranslateModule } from '@ngx-translate/core';

// Forms
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Custom Shared Material Module
import { SharedMaterialModule } from './shared-material.module.ts/shared-material-module';
import { FunctionsUtilsService, TypesUtilsService } from '../core/core.index';
import { TimeAgoPipe } from '../core/pipes/time-ago.pipe';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,

    // Third-party Libraries
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    NgxMaskModule.forRoot({
      showMaskTyped: false,
    }),
    NgxEditorModule,
    NgScrollbarModule,
    ClipboardModule,
    DragDropModule,
    ScrollingModule,
    ToastrModule.forRoot({
      timeOut: 1000,
      progressBar: true,
      progressAnimation: 'increasing',
      preventDuplicates: true,
    }),
    LightboxModule,
    TooltipModule.forRoot(),
    NgChartsModule.forRoot(),
    NgApexchartsModule,
    CarouselModule,
    ToastModule,
    NgxDropzoneModule,
    TranslateModule,

    // Shared Material Module
    SharedMaterialModule,
    TimeAgoPipe
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,

    // Third-party Libraries
    BsDatepickerModule,
    TimepickerModule,
    NgxMaskModule,
    NgScrollbarModule,
    ClipboardModule,
    DragDropModule,
    ScrollingModule,
    ToastrModule,
    LightboxModule,
    TooltipModule,
    NgChartsModule,
    NgApexchartsModule,
    NgxEditorModule,
    CarouselModule,
    ToastModule,
    NgxDropzoneModule,
    TranslateModule,

    // Shared Material Module
    SharedMaterialModule,
    TimeAgoPipe
  ],
  providers: [BsDatepickerConfig, DatePipe, TypesUtilsService, FunctionsUtilsService, TimeAgoPipe],
})
export class SharedModule {}